import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import AllDataClass from "pages/common/AllDataClass";
import "./ConflictPolicy.scss";
import { useTranslation } from "react-i18next";

type ItemProp = {
  open: boolean;
  prev_policy: string;
  cur_policy: string;
  conflictModalClose: () => void;
  setSelectedPolicyLists: React.Dispatch<React.SetStateAction<any[]>>;
};
const ConflictPolicy = ({
  open,
  prev_policy,
  cur_policy,
  conflictModalClose,
  setSelectedPolicyLists,
}: ItemProp) => {
  const onClickHander = () => {
    conflictModalClose();
  };
  const { t } = useTranslation();

  if (!prev_policy || !cur_policy) return;

  const prevPolicy = AllDataClass.getPolicyDescriptivebyID(prev_policy);
  const curPolicy = AllDataClass.getPolicyDescriptivebyID(cur_policy);
  const onClickContinue = () => {
    AllDataClass.removeSelectedList(prev_policy);
    AllDataClass.addSelectedList(cur_policy);
    setSelectedPolicyLists(AllDataClass.getSelectedList());
    conflictModalClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="policy-modal-main"
    >
      <div className="conflict-modal-main">
        <div className="conflict-modal-wrap">
          <div className="title">{t("confilcted-policy")}</div>
          <div className="content-wrap">
            <div className="content-explain">
              <div className="explain">{t("pre-policy")}</div>
              <div className="explain">{t("cur-policy")}</div>
            </div>
            <div className="content">
              <div className="content-card">
                <div className="content-policy">
                  <div className="card">
                    <div className="card-name">{prevPolicy[2]}</div>
                    <div className="card-category">{prevPolicy[0]}</div>
                  </div>
                  <div className="card-selected" />
                </div>
                <div className="content-arrow"></div>
                <div className="content-policy">
                  <div className="card">
                    <div className="card-name">{curPolicy[2]}</div>
                    <div className="card-category">{curPolicy[0]}</div>
                  </div>
                </div>
              </div>
              <div className="content-button">
                <div className="button">
                  <button className="keep" onClick={onClickHander}>
                    <span>{t("keep-policy")}</span>
                  </button>
                </div>
                <div className="button">
                  <button className="continue" onClick={onClickContinue}>
                    <span>{t("continue")}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConflictPolicy;
